var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isClosed)?_c('p',[_vm._v("受付終了")]):_c('p',[_vm._v("参加受付終了まで "),_c('b',[(_vm.days > 0)?_c('span',[_vm._v(_vm._s(_vm.days)+"日 ")]):_vm._e(),_vm._v(_vm._s(_vm._f("twoDigits")(_vm.hours))+":"+_vm._s(_vm._f("twoDigits")(_vm.minutes))+":"+_vm._s(_vm._f("twoDigits")(_vm.seconds)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }